import { ChannelSchema } from "@redotech/redo-model/marketplace/channels";
import * as z from "zod";

export const deleteMarketplaceListing = {
  name: "deleteMarketplaceListing" as const,
  input: z.object({ listingId: z.string(), channel: ChannelSchema }),
  output: z.object({ success: z.boolean() }),
};
